export default "__VITE_ASSET__0fa7cfff__"